import { render, staticRenderFns } from "./electric-bike-insurance.vue?vue&type=template&id=0041a22e&scoped=true"
import script from "./electric-bike-insurance.vue?vue&type=script&lang=js"
export * from "./electric-bike-insurance.vue?vue&type=script&lang=js"
import style0 from "./electric-bike-insurance.vue?vue&type=style&index=0&id=0041a22e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0041a22e",
  null
  
)

export default component.exports